import React from "react";
import ReactPlayer from "react-player";
import "./styles.scss";

const StoryVideo = (videoLink) => {
  return (
    <section className="home-video-container">
      <ReactPlayer
        controls={true}
        width={"100%"}
        height={850}
        url={videoLink?.videoLink}
      />
    </section>
  );
};

export default StoryVideo;
